<template>
  <div class="welcome">
    <section class="headtop">
      <div class="container">
        <h1>Welcome to C19UDM</h1>
        <p>
          C19UDM is designed to simulate travel and employment in a medium-sized
          town under COVID 19 lockdown, and what can happen as lockdown is
          lifted. You can watch how conditions in the town change over time and
          make decisions about transport and other things to try to improve
          matters.
          <br><br>
          The model advances in steps of one week and will simulate up to three
          years.
          <br><br>
          The results are not to be treated as forecasts; you will find that a
          range of results can be obtained, depending on your choice of starting
          conditions and the decisions you make. Think of it as a way of
          rehearsing different lockdown scenarios and searching for the most
          effective ways of alleviating their worst impacts.
          <br><br>
          C19UDM is not a model of how the COVID virus spreads; it is not an
          epidemiological model. It takes the consequences of the virus, such as
          social distancing, as inputs and demonstrates their effects on some
          aspects of this fictional town.
          <br><br>
          C19UDM, based on Steer’s Urban Dynamic Model, was developed with
          funding from Innovate UK.
        </p>
        <div class="clearfix" />
      </div>
    </section>
    <div class="container">
      <div class="row">
        <div class="col-md-3 column">
          <h4>The Town</h4>
          <p>
            The model simulates a medium-sized town, with a mix of smaller
            settlements around it.
            <br><br>
            It has a rail station and is well served by buses. Around 80% of
            commuting trips into the town are by car, 1% by rail, and 8% by bus.
            A further 10% are by walk and cycle.
            <br><br>
            To see more about what happens when lockdown starts,
            <a
              href
              @click.prevent="displayModal('modelinfo')"
            ><b>click here</b></a>.
          </p>
        </div>
        <div class="col-md-9 column">
          <img
            src="/static/img/udm/Random_Town-01.png"
            class="map"
          >
        </div>
      </div>
    </div>
    <div class="widget bottom-widget">
      <div class="container">
        <div class="pull-right">
          <router-link
            to="/scenarios"
            class="btn btn-primary btn-lg"
          >
            Next
          </router-link>
        </div>
        <div class="clearfix" />
      </div>
    </div>
    <template v-if="savedRuns.length > 0">
      <div class="widget bottom-widget">
        <div class="container">
          <div class="row">
            <h4>Saved runs:</h4>
            <table class="table table-striped">
              <tbody>
                <template v-for="(run, index) in savedRuns">
                  <tr :key="index">
                    <td>
                      {{ run.name }}
                    </td>
                    <td class="text-right">
                      <button
                        class="btn btn-sm btn-primary"
                        @click="loadRun(index)"
                      >
                        <span>View</span>
                      </button>
                      &nbsp;
                      <button
                        class="btn btn-sm btn-primary"
                        @click="deleteRunButtonClicked(index)"
                      >
                        <span>Delete</span>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="clearfix" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sharedStorage: this.$root.$data.sharedStorage,
      savedRuns: this.$root.$data.sharedStorage.getSavedRuns(),
      mapPopupData: {},
      selectedIndexToDelete: -1
    };
  },
  created() {
    this.$root.$data.eventHub.$on(
      "show-deletesavedrun-trigger",
      this.deleteRun
    );
  },
  methods: {
    loadRun(index) {
      const savedRun = this.sharedStorage.getSavedRuns()[index];
      this.sharedStorage.loadSavedRun({ savedData: savedRun });
      this.$router.push("/results");
    },
    deleteRunButtonClicked(index) {
      this.selectedIndexToDelete = index;
      this.$root.$data.eventHub.$emit("show-deletesavedrun-modal");
    },
    deleteRun() {
      if (this.selectedIndexToDelete < 0) {
        return;
      }
      this.sharedStorage.deleteSavedRun({ index: this.selectedIndexToDelete });
      this.savedRuns = this.sharedStorage.getSavedRuns();
      this.selectedIndexToDelete = -1;
    },
    displayModal(modalName) {
      this.$root.$data.eventHub.$emit("show-" + modalName + "-modal");
    }
  }
};
</script>

<style lang="scss">
.map {
  width: 100%;
}
</style>
